/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { de, en } from 'vuetify/locale'

const highQColors = {
    tiefblau: '#00296e',
    mittelblau: '#0c68b0',
    hellblau: '#47afe8',
    gelb: '#e39606',
    orange: '#dc5f13',
    weiss: '#ffffff',
    hellgrau: '#e6e6e6',
    dunkelgrau: '#b3b3b3',
    schwarz: '#1aa037',
    zeitmeilengruen: '#1aa037'
}

const dbRegioColors = {
    success: '#508b1b',
    info: '#0087b9',
    warn: '#fff000',
    error: '#ec0016',
    positivefeedback: '#508b1b',
    primary: '#ec0016',
    backgroundprimary: '#fff',
}

// Composables
import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import { VDateInput } from 'vuetify/labs/VDateInput'

const highQTheme = {
    dark: false,
    colors: {
        background: highQColors.hellgrau,
        primary: highQColors.mittelblau,
        error: '#C00000',
        info: highQColors.mittelblau,
        success: highQColors.zeitmeilengruen,
        warning: highQColors.gelb,
        'primary-lighten': '#EEF7FF',
    },
    variables: {
        'disabled-opacity': 0.9,
    }
}

const dbRegioTheme = {
    dark: false,
    colors: {
        background: dbRegioColors.backgroundprimary,
        primary: dbRegioColors.primary,
        error: dbRegioColors.error,
        info: dbRegioColors.info,
        success: dbRegioColors.positivefeedback,
        warning: dbRegioColors.warn,
        'primary-lighten': '#ffeaea',
    },
    variables: {
        'disabled-opacity': 0.9,
    }
}

const tgoTheme = {
    dark: false,
    colors: {
        background: highQColors.hellgrau,
        primary: '#519a28',
        error: '#C00000',
        info: highQColors.mittelblau,
        success: highQColors.zeitmeilengruen,
        warning: highQColors.gelb,
        'primary-lighten': '#EEF7FF',
    },
    variables: {
        'disabled-opacity': 0.9,
    }
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    components: {
        VDateInput,
    },
    theme: {
        defaultTheme: 'highQTheme',
        themes: {
            highQTheme,
            tgoTheme,
            dbRegioTheme
        }
    },
    locale: {
        locale: 'de',
        fallback: 'en',
        messages: { de, en },
    },
    aliases: {
        VBtnPrimary: VBtn,
        VBtnSecondary: VBtn,
        VBtnTableAction: VBtn,
    },
    defaults: {
        VBtn: {
            style: [ { textTransform: 'none' } ],
        },
        VBtnPrimary: {
            color: 'primary',
            variant: 'elevated',
            style: [ { textTransform: 'none' } ],
        },
        VBtnSecondary: {
            style: [ { textTransform: 'none' } ],
        },
        VBtnTableAction: {
            icon: 'mdi-dots-horizontal',
            color: 'primary',
            density: 'comfortable'
        },
        VTextField: {
            color: 'primary',
            variant: 'underlined'
        },
        VTextarea: {
            color: 'primary'
        },
        VAutocomplete: {
            color: 'primary',
            variant: 'underlined',
            VChip: {
                color: 'primary',
                variant: 'flat',
            }
        },
        VDateInput: {
            color: 'primary',
            variant: 'underlined'
        },
        VSelect: {
            color: 'primary',
            variant: 'underlined',
            VChip: {
                color: 'primary',
                variant: 'flat',
            }
        },
        VCheckbox: {
            color: 'primary'
        },
        VCheckboxBtn: {
            color: 'primary'
        },
        VDatePicker: {
            color: 'primary',
        },
        VRadioGroup: {
            color: 'primary'
        }
    }
})
